// Thin fetch wrapper for the participant + peer + admin APIs.

async function req(method, path, body) {
  const res = await fetch(path, {
    method,
    headers: body ? { "content-type": "application/json" } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  if (!res.ok) {
    let msg = res.statusText;
    try { msg = (await res.json()).error || msg; } catch {}
    throw new Error(msg);
  }
  return res.status === 204 ? null : res.json();
}

export const api = {
  // Participant
  session: (token) => req("GET", `/api/session?token=${encodeURIComponent(token)}`),
  consent: (token) => req("POST", `/api/consent`, { token }),
  save: (payload) => req("POST", `/api/save`, payload),
  submit: (token) => req("POST", `/api/submit`, { token }),
  addLink: (payload) => req("POST", `/api/link`, payload),
  addAsset: (payload) => req("POST", `/api/asset`, payload),
  deleteAsset: (token, id) => req("DELETE", `/api/asset?token=${encodeURIComponent(token)}&id=${id}`),
  uploadUrl: (payload) => req("POST", `/api/upload-url`, payload),

  // Section B reactions (outside the questionnaire, never touches progress)
  react: (payload) => req("POST", `/api/react`, payload),

  // Peer / mirror
  peerLoad: (token) => req("GET", `/api/peer?token=${encodeURIComponent(token)}`),
  peerSubmit: (payload) => req("POST", `/api/peer`, payload),
  peerUploadUrl: (payload) => req("POST", `/api/peer-upload-url`, payload),

  // Admin
  adminList: () => req("GET", `/api/admin/participants`),
  adminCreate: (payload) => req("POST", `/api/admin/participants`, payload),
  adminDeleteParticipant: (id) => req("DELETE", `/api/admin/participants?id=${id}`),
  adminSectors: () => req("GET", `/api/admin/sectors`),
  adminParticipant: (id) => req("GET", `/api/admin/participant/${id}`),
  adminTailor: (payload) => req("POST", `/api/admin/tailor`, payload),
  adminUntailor: (id) => req("DELETE", `/api/admin/tailor?id=${id}`),
  adminUploadAudit: (payload) => req("POST", `/api/admin/audit`, payload),
  adminDeleteAudit: (id) => req("DELETE", `/api/admin/audit?id=${id}`),
  adminTranscribe: (payload) => req("POST", `/api/admin/transcribe`, payload),
  adminAnalyze: (payload) => req("POST", `/api/admin/analyze`, payload),
  adminImportAnalysis: (payload) => req("POST", `/api/admin/audit-import`, payload),
  adminPublishAudit: (payload) => req("PUT", `/api/admin/audit`, payload),
  adminReact: (id) => req("GET", `/api/admin/react?id=${id}`),
  adminReactSave: (payload) => req("POST", `/api/admin/react`, payload),
  adminReactDelete: (id, target = "item") => req("DELETE", `/api/admin/react?id=${id}&target=${target}`),
  adminReactTranscribe: (id) => req("PUT", `/api/admin/react?id=${id}`),
  adminPostpool: () => req("GET", `/api/admin/postpool`),
  adminSavePost: (payload) => req("POST", `/api/admin/postpool`, payload),
  adminDeletePost: (id) => req("DELETE", `/api/admin/postpool?id=${id}`),
};

// Upload a Blob straight to R2 via a presigned PUT, then register the asset.
export async function uploadToR2({ token, quest_key, question_key, kind, blob, filename, peer }) {
  const mime = blob.type || "application/octet-stream";
  const qs = new URLSearchParams({ token, question_key, filename: filename || "upload" });
  if (peer) qs.set("peer", "1");
  const res = await fetch(`/api/upload?${qs.toString()}`, {
    method: "POST", headers: { "content-type": mime }, body: blob,
  });
  if (!res.ok) {
    let msg = "Upload failed";
    try { msg = (await res.json()).error || msg; } catch {}
    throw new Error(msg);
  }
  const data = await res.json();
  return { key: data.key, mime };
}
